import { styled } from '@mui/system'

const LoginTermsBox = styled('div')(({ theme }) => ({
	width: '34.1rem',
	height: '34rem',
	backgroundColor: theme.palette.grey[100],
	boxShadow: '0 1rem 1.875rem 0 rgba(0, 0, 0, 0.25)',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	borderRadius: '0.625rem',
}))

const ConfirmTermsForm = styled('form')(({ theme }) => ({
	padding: '1.25rem',
	backgroundColor: theme.palette.grey[100],
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'center',

	'>button': {
		padding: '0.3125rem 1rem',
		marginLeft: '0.3125rem',
		cursor: 'pointer',

		'&:disabled': {
			cursor: 'default',
		},
	},

	'& .MuiTypography-root': {
		fontSize: '0.875rem',
	},
}))

export { LoginTermsBox, ConfirmTermsForm }
